module.exports = __webpack_public_path__ + "img/obstacle.9a080f31.png";